import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Eyebrow } from './UI';
import { ChevronDown } from 'lucide-react';
export const FAQ = () => {
  const faqs = [{
    q: 'Is this mask actually rated for airsoft and high-FPS play?',
    a: 'Yes. The BLACKOUT UNIT Ultimate Mask uses Lexan polycarbonate lenses rated ANSI Z87.1 — the industry standard for airsoft eye protection. Tested at direct BB impact up to 250+ FPS. For fields running 400+ FPS, standard 10-meter minimum engagement rules apply. The composite shell provides full-face coverage against fragmentation, debris, and impact.'
  }, {
    q: 'How do I swap the lenses?',
    a: 'Tool-free. Press the two release tabs on either side of the lens frame, slide the lens forward, remove. New lens pushes in and locks with an audible click. Average swap time: under 30 seconds in the field.'
  }, {
    q: 'Does it fit over eyeglasses?',
    a: 'The interior foam padding is designed to seat directly against your face. Many users with thin wire-frame glasses report a comfortable fit. Customers with thicker frames may find the Clear lens configuration provides the most interior clearance.'
  }, {
    q: 'What exactly does "lifetime warranty" cover?',
    a: 'The frame, composite shell, stainless steel skeleton, and strap hardware are warranted against structural defect under normal operational use — for life. Lenses carry a 1-year anti-fog coating and anti-scratch warranty. The warranty does not cover intentional destruction or acts of extreme force outside normal use (our F-250 test was our idea — not yours).'
  }, {
    q: 'Is this mask legal for regulated airsoft fields?',
    a: "The BLACKOUT UNIT meets ANSI Z87.1 standards — the baseline requirement at most regulated airsoft and paintball venues in the United States. We always recommend confirming with your specific field's safety officer prior to competition play."
  }, {
    q: "What's your return process?",
    a: '30 days. No questions. Contact us at support@blackoutunit.com or call +1 (800) 000-0000. We send a prepaid return label. Refunds processed within 3–5 business days of receipt.'
  }, {
    q: 'Do you offer bulk or wholesale for teams?',
    a: 'Yes. Email wholesale@blackoutunit.com with your organization, quantity needed, and intended application. Response within 24 hours with a custom quote and team discount structure.'
  }, {
    q: 'What makes this different from every other skull mask?',
    a: 'Material category. Every competitor uses ABS or PVC injection plastic — materials that crack, warp, and fail within a season of hard use. The BLACKOUT UNIT uses glass-fiber reinforced composite shell over a Grade 304 stainless steel skeleton. It is a fundamentally different product in the same visual category.'
  }];
  const half = Math.ceil(faqs.length / 2);
  const col1 = faqs.slice(0, half);
  const col2 = faqs.slice(half);
  const AccordionItem = ({
    q,
    a
  }: {
    q: string;
    a: string;
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    return <div className="bg-dark-1 border border-dark-3 hover:border-dark-2 transition-colors mb-4" data-id="element-70">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center p-6 text-left" data-id="element-71">
          <span className="font-bebas text-xl text-white pr-4" data-id="element-72">{q}</span>
          <ChevronDown className={`text-acid-green shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-73" />
        </button>
        <AnimatePresence data-id="element-74">
          {isOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} className="overflow-hidden" data-id="element-75">
              <div className="p-6 pt-0 font-inter text-sm text-text-dimmed leading-relaxed border-t border-dark-3/50 mt-2" data-id="element-76">
                {a}
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>;
  };
  return <section className="relative py-[100px]" data-id="element-77">
      {/* Background Image with Dark Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-78">
        <img src="https://cdn.magicpatterns.com/uploads/nG8ULCaEp4SdxkWLmpe5za/hf_20260505_163744_f1440f2b-fb41-4cb5-8671-6935791fc173.png" alt="Blackout Unit Silver Mask" className="w-full h-full object-cover opacity-50" data-id="element-79" />
        <div className="absolute inset-0 bg-gradient-to-b from-base-black via-base-black/50 to-base-black" data-id="element-80"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <Eyebrow data-id="element-83">FIELD INTEL</Eyebrow>
          <h2 className="text-5xl md:text-[64px] leading-[0.9] mb-4" data-id="element-84">
            GOT QUESTIONS?{' '}
            <span className="text-acid-green" data-id="element-85">WE'VE GOT ANSWERS.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8" data-id="element-86">
          <div data-id="element-87">
            {col1.map((faq, i) => <AccordionItem key={i} {...faq} data-id="element-88" />)}
          </div>
          <div data-id="element-89">
            {col2.map((faq, i) => <AccordionItem key={i} {...faq} data-id="element-90" />)}
          </div>
        </div>
      </div>
    </section>;
};